export const YELLOW = '#f6f233';
export const TOTAL_BG = '#ffb5b5';
export const CATEGORY_FOOTER_BG = '#f3f3f3';
export const HEADER_GROUP_BG = '#d6ffd6';
export const HEADER_ADJ_BG = '#9ed6fc';
